import * as React from "react";

import { Icon } from "../../Icons/Icon";
import { trackAction } from "../../Internals/Metrics/MetricsProvider";
import { FORM_CLOSE_CLICK } from "../../metricsAction";

import { CloseIcon, Container, TitleText } from "./ModalHeader.styles";

export interface ModalHeaderProps {
    children?: React.ReactNode;

    text?: string;
    showingCloseButton: boolean;

    onCloseForm: () => Promise<void>;
}

export class ModalHeader extends React.Component<ModalHeaderProps> {
    public static isModalHeaderComponent(node: React.ReactNode) {
        const isReactElement = React.isValidElement(node) && node.type !== "string";
        const elementType = isReactElement && node.type;

        const isObjectElementType = elementType && typeof elementType !== "string";
        const hasDisplayName = isObjectElementType && "displayName" in elementType;

        // кастуем из-за недостаточно мощного вывода типов в текущей версии typescript
        // не получается без костылей объяснить, что elementType имеет тип не never
        const castedElementType = elementType as unknown as Record<"displayName", string>;

        return Boolean(
            hasDisplayName &&
                typeof castedElementType.displayName === "string" &&
                castedElementType.displayName === ModalHeader.name
        );
    }

    public render(): React.ReactNode {
        return (
            <Container>
                <TitleText>{this.props.children ?? this.props.text}</TitleText>

                {this.props.showingCloseButton && (
                    <CloseIcon onClick={this.closeFormAction}>
                        <Icon size={24} name={"XIcon"} />
                    </CloseIcon>
                )}
            </Container>
        );
    }

    @trackAction(FORM_CLOSE_CLICK)
    private readonly closeFormAction = async (): Promise<void> => {
        await this.props.onCloseForm();
    };
}
